import { useReducer } from 'react';
import { ClaimRequest, GapClaimType, ProductType } from '../common/CommonTypes';
import { ClaimContextState, ClaimState } from '../../context/ClaimContext';

export type Action =
    | { type: 'set-gapclaim'; gapClaim: GapClaimType }
    | { type: 'set-product-reference'; productReference: ProductType }
    | { type: 'set-claim-request'; claimRequest: ClaimRequest };

const ClaimReducer = (state: ClaimState, action: Action) => {
    switch (action.type) {
        case 'set-gapclaim': {
            return {
                ...state,
                gapClaim: action.gapClaim
            };
        }
        case 'set-product-reference': {
            return {
                ...state,
                productReference: action.productReference
            };
        }
        case 'set-claim-request': {
            return {
                ...state,
                claimRequest: action.claimRequest
            };
        }
        default: {
            return state;
        }
    }
};

function useClaimTypes(initialState?: ClaimState): ClaimContextState {
    if (initialState === undefined) {
        initialState = {
            gapClaim: {},
            productReference: null,
            claimRequest: null
        };
    }

    const [gapClaimTypes, dispatch] = useReducer(ClaimReducer, initialState);

    const { gapClaim, productReference, claimRequest } = gapClaimTypes;

    const setGapClaim = (gapClaim: GapClaimType): void => {
        dispatch({ type: 'set-gapclaim', gapClaim });
    };

    const setGapProductReference = (gapProduct: ProductType): void => {
        dispatch({
            type: 'set-product-reference',
            productReference: gapProduct
        });
    };

    const setClaimRequest = (req: ClaimRequest): void => {
        dispatch({
            type: 'set-claim-request',
            claimRequest: req
        });
    };

    return {
        gapClaim,
        productReference,
        claimRequest,
        setGapClaim,
        setGapProductReference,
        setClaimRequest
    };
}

export default useClaimTypes;
